<template lang="pug">
.extra-visit-page
  .content
    .hero
      .brand-row
        img.logo(src="@/assets/logo.png")
        span 袋鼠照护
      .city-pill {{ page.cityLabel }}
      h1 {{ page.title }}
      p.hero-subtitle {{ page.subtitle }}
      .price-panel
        .price-main
          span.currency ¥
          span.amount {{ page.price }}
          span.unit /次
        .price-note {{ page.priceNote }}
      .hero-tags
        span(v-for="tag in page.tags" :key="tag") {{ tag }}

    .section
      .section-title
        span.index 01
        h2 什么情况下，建议加一次上门？
      .reason-list
        .reason-item(v-for="item in page.reasons" :key="item.title")
          span.dot
          .reason-copy
            h3 {{ item.title }}
            p {{ item.desc }}

    .section
      .section-title
        span.index 02
        h2 这次上门，我们重点看什么？
      .service-grid
        .service-card(v-for="item in serviceItems" :key="item.title")
          span.service-icon {{ item.icon }}
          h3 {{ item.title }}
          p {{ item.desc }}

    .section
      .section-title
        span.index 03
        h2 {{ page.scopeTitle }}
      .scope-box
        .scope-row(v-for="item in page.scope" :key="item.label")
          span.scope-label {{ item.label }}
          span.scope-value {{ item.value }}

    .section
      .section-title
        span.index 04
        h2 买之前，先把规则说清楚
      .rule-list
        .rule-item(v-for="rule in page.rules" :key="rule") {{ rule }}

    .section.compare-section
      .section-title
        span.index 05
        h2 怎么选？
      .choice-table
        .choice-row.header
          span 情况
          span 建议
        .choice-row(v-for="item in page.choices" :key="item.scene")
          span {{ item.scene }}
          span {{ item.suggestion }}

    .bottom-action
      .bottom-copy
        span.bottom-title {{ page.bottomTitle }}
        span.bottom-desc {{ page.bottomDesc }}
      button.buy-button(type="button" @click="handleBuy") 预约加购
</template>

<script>
const pageMap = {
    beijing: {
        cityLabel: '北京 · 市内额外上门',
        title: '不是再买一次服务，是让照护师到家里把关键问题看清楚',
        subtitle: '适合已经购买服务包，但宝宝近期出现喂养、睡眠、发育训练或家长判断不准的问题，需要照护师到家里现场评估和纠偏。',
        price: 699,
        priceNote: '北京市内服务包用户加购价',
        tags: ['2小时上门', '提前预约', '服务包用户专享'],
        scopeTitle: '北京服务范围与预约',
        scope: [
            { label: '适用范围', value: '北京市内，具体地址需提前确认' },
            { label: '预约时间', value: '建议提前24小时预约' },
            { label: '服务时长', value: '单次约2小时' },
            { label: '超出范围', value: '远距离、特殊时间段需确认交通补差' }
        ],
        reasons: [
            { title: '家长觉得宝宝“好像没问题”，但心里不踏实', desc: '早产宝宝很多问题不是肉眼一眼能判断，上门可以把喂养、姿势、训练、环境一起看。' },
            { title: '线上说不清，视频也看不全', desc: '吃奶姿势、抱姿、肌张力、睡眠环境、训练动作，很多细节需要现场观察。' },
            { title: '想在关键节点做一次复核', desc: '体重追赶、神经发育训练、复诊前后，都适合加一次上门，把下一阶段照护重点定清楚。' }
        ],
        rules: [
            '额外上门只面向已购买服务包的家庭开放。',
            '单次上门服务约2小时，不作为紧急医疗服务。',
            '已完成预约并实际出发后，如临时取消，需按平台规则扣除已发生费用。',
            '上门中发现需要就医的问题，会建议家长及时前往医院。'
        ],
        choices: [
            { scene: '只是想问几个日常问题', suggestion: '优先用图文或电话咨询' },
            { scene: '训练动作总做不对', suggestion: '建议加购上门' },
            { scene: '宝宝近期吃奶、睡眠、体重波动明显', suggestion: '建议加购上门并同步回访' },
            { scene: '需要医生诊断或处理急症', suggestion: '直接就医，不用上门替代' }
        ],
        bottomTitle: '北京额外上门 699元/次',
        bottomDesc: '适合关键节点现场复核。'
    },
    tianjin: {
        cityLabel: '天津 · 市内额外上门',
        title: '线上判断不够时，加一次上门，把宝宝状态重新校准',
        subtitle: '天津家庭更看重上门的确定性。额外上门适合服务期内临时出现问题，或想在月龄关键节点让照护师到家里看一次。',
        price: 599,
        priceNote: '天津市内服务包用户加购价',
        tags: ['2小时上门', '关键节点纠偏', '提前预约'],
        scopeTitle: '天津服务范围与预约',
        scope: [
            { label: '适用范围', value: '天津市内，具体地址需提前确认' },
            { label: '预约时间', value: '建议提前24小时预约' },
            { label: '服务时长', value: '单次约2小时' },
            { label: '适合家庭', value: '已购买天津服务包，想增加一次现场指导' }
        ],
        reasons: [
            { title: '关键节点到了，需要有人到家看一次', desc: '满月、2月龄、训练调整、复诊前后，都适合现场复核。' },
            { title: '家里操作和线上说法对不上', desc: '照护师到家可以直接看动作、看环境、看喂养过程，减少反复试错。' },
            { title: '家人意见不统一', desc: '上门时可以把照护方法讲清楚，让宝爸、老人和妈妈有同一套执行标准。' }
        ],
        rules: [
            '额外上门需在服务周期内预约使用。',
            '单次上门服务约2小时，重点解决本次预约的核心问题。',
            '不承诺当天上门，具体时间以照护师排班为准。',
            '超出服务范围或特殊时间段，需提前确认。'
        ],
        choices: [
            { scene: '只是补充问喂养小问题', suggestion: '优先图文咨询' },
            { scene: '宝宝训练动作需要手把手纠正', suggestion: '建议加购上门' },
            { scene: '老人和父母照护方式冲突', suggestion: '建议加购上门统一方法' },
            { scene: '需要更多长期陪伴', suggestion: '优先考虑升级深度陪伴版' }
        ],
        bottomTitle: '天津额外上门 599元/次',
        bottomDesc: '适合服务期内加一次关键节点上门。'
    },
    shijiazhuang: {
        cityLabel: '石家庄 · 市内额外上门',
        title: '需要再到家里看一次，就加购一次正式上门',
        subtitle: '适合石家庄市内服务包用户，在原套餐上门次数之外，临时增加一次现场评估、动作纠偏或家庭照护指导。',
        price: 499,
        priceNote: '石家庄市内服务包用户加购价',
        tags: ['市内上门', '2小时指导', '服务包用户专享'],
        scopeTitle: '石家庄市内服务范围',
        scope: [
            { label: '适用范围', value: '石家庄市内' },
            { label: '预约时间', value: '建议提前24小时预约' },
            { label: '服务时长', value: '单次约2小时' },
            { label: '使用方式', value: '服务期内按次加购，不自动顺延服务期' }
        ],
        reasons: [
            { title: '套餐里的上门用完了，但还想再看一次', desc: '宝宝月龄变化快，家长需要在新的阶段重新确认喂养和训练重点。' },
            { title: '视频看得到，但家长做不到位', desc: '动作力度、抱姿角度、家庭环境，现场纠偏会更直接。' },
            { title: '想用较低成本补一次上门', desc: '市内加购价格低于北京天津，适合作为服务期内的灵活补充。' }
        ],
        rules: [
            '额外上门只面向已购买服务包的家庭开放。',
            '每次加购仅包含一次上门，不包含新增长期服务周期。',
            '预约后如需改期，请尽量提前沟通。',
            '如宝宝存在明显异常，应优先就医。'
        ],
        choices: [
            { scene: '想再看一次体重、喂养和训练', suggestion: '适合加购上门' },
            { scene: '只需要看动作视频', suggestion: '可先用视频指导' },
            { scene: '家里人执行不一致', suggestion: '适合加购上门统一照护方法' },
            { scene: '距离不在市内', suggestion: '选择周边额外上门或视频版' }
        ],
        bottomTitle: '石家庄市内额外上门 499元/次',
        bottomDesc: '适合服务期内灵活补充一次上门。'
    },
    shijiazhuangNearby: {
        cityLabel: '石家庄周边 · 额外上门',
        title: '周边上门要提前确认，能视频解决的优先视频',
        subtitle: '周边家庭路程更远，照护师出行和排班成本更高。确实需要到家时，可以单独加购周边上门；普通问题优先视频指导。',
        price: 599,
        priceNote: '石家庄周边服务包用户加购价',
        tags: ['需确认范围', '提前24-48小时', '可优先视频'],
        scopeTitle: '周边服务范围与预约',
        scope: [
            { label: '适用范围', value: '石家庄周边，具体地址需提前确认' },
            { label: '预约时间', value: '建议提前24-48小时预约' },
            { label: '服务时长', value: '单次约2小时，不含长距离等待' },
            { label: '交通补差', value: '远距离、跨县区、特殊时间段需另行确认' }
        ],
        reasons: [
            { title: '视频解决不了，需要到家里实际看', desc: '如果涉及喂养姿势、训练手法、家庭环境，必要时可以安排一次周边上门。' },
            { title: '宝宝处在关键调整期', desc: '复诊后、月龄转换、训练方案变化时，上门能帮助家长把新计划落到家里。' },
            { title: '希望减少来回折腾', desc: '周边家庭就医和线下沟通成本更高，一次上门可以集中处理多个照护问题。' }
        ],
        rules: [
            '周边额外上门不承诺当天达，需提前预约。',
            '下单前需确认地址是否在可服务范围。',
            '如距离较远或交通成本明显增加，需补交通差价。',
            '能通过视频解决的问题，会优先建议视频服务。'
        ],
        choices: [
            { scene: '普通喂养、睡眠、训练问题', suggestion: '优先视频指导' },
            { scene: '家长操作一直做不对', suggestion: '可加购周边上门' },
            { scene: '地址较远或跨县区', suggestion: '先确认排班和交通补差' },
            { scene: '宝宝出现急症表现', suggestion: '优先就近就医' }
        ],
        bottomTitle: '石家庄周边额外上门 599元/次',
        bottomDesc: '下单前请先确认服务范围。'
    }
};

export default {
    computed: {
        currentKey () {
            const name = this.$route.params.region || this.$route.query.region || 'beijing';
            if (name === 'shijiazhuang-nearby') {
                return 'shijiazhuangNearby';
            }
            if (name === 'nearby') {
                return 'shijiazhuangNearby';
            }
            return pageMap[name] ? name : 'beijing';
        },
        page () {
            return pageMap[this.currentKey];
        },
        serviceItems () {
            return [
                {
                    icon: '1',
                    title: '现场评估宝宝状态',
                    desc: '看体重、吃奶、睡眠、精神反应、姿势和训练执行情况，先判断问题在哪里。'
                },
                {
                    icon: '2',
                    title: '纠正家庭操作',
                    desc: '把抱姿、喂养姿势、训练动作、抚触方式在家里重新示范一遍。'
                },
                {
                    icon: '3',
                    title: '调整下一步计划',
                    desc: '根据宝宝当下状态，给家长明确接下来一段时间怎么喂、怎么练、怎么观察。'
                },
                {
                    icon: '4',
                    title: '同步家人照护标准',
                    desc: '把妈妈、宝爸、老人最容易分歧的地方讲清楚，让家里执行同一套方法。'
                }
            ];
        }
    },
    methods: {
        handleBuy () {
            if (this.$toast) {
                this.$toast('已为你记录加购意向，请联系照护师确认时间');
            }
        }
    }
};
</script>

<style lang="sass" scoped>
.extra-visit-page
  min-height: 100vh
  background: #F5F7F4
  color: #24352E
  padding-bottom: 92px

.content
  max-width: 760px
  margin: 0 auto
  padding: 16px 14px 0

.hero
  border-radius: 0 0 28px 28px
  background: linear-gradient(160deg, #FDF8EF 0%, #EFF7F0 54%, #FFFFFF 100%)
  padding: 22px 18px 24px
  border: 1px solid rgba(47, 95, 73, 0.12)
  box-shadow: 0 18px 45px rgba(41, 74, 58, 0.12)

.brand-row
  display: flex
  align-items: center
  gap: 8px
  color: #315F48
  font-size: 14px
  font-weight: 700

.logo
  width: 28px
  height: 28px
  object-fit: contain

.city-pill
  display: inline-flex
  margin-top: 18px
  padding: 6px 10px
  border-radius: 999px
  background: rgba(49, 95, 72, 0.1)
  color: #315F48
  font-size: 12px
  font-weight: 700

h1
  margin: 12px 0 10px
  font-size: 28px
  line-height: 1.22
  font-weight: 900
  color: #20382B

.hero-subtitle
  margin: 0
  font-size: 15px
  line-height: 1.72
  color: #5B6C62

.price-panel
  margin-top: 18px
  padding: 16px
  border-radius: 8px
  background: #FFFFFF
  border: 1px solid rgba(49, 95, 72, 0.12)
  display: flex
  justify-content: space-between
  align-items: flex-end
  gap: 12px

.price-main
  color: #B85B35
  font-weight: 900

.currency
  font-size: 20px

.amount
  font-size: 42px
  line-height: 1

.unit
  font-size: 14px
  color: #7C5F4C

.price-note
  font-size: 13px
  color: #607268
  text-align: right
  line-height: 1.4

.hero-tags
  display: flex
  flex-wrap: wrap
  gap: 8px
  margin-top: 14px

.hero-tags span
  padding: 6px 9px
  border-radius: 6px
  background: rgba(184, 91, 53, 0.1)
  color: #8A4B31
  font-size: 12px
  font-weight: 700

.section
  margin-top: 14px
  padding: 18px 16px
  border-radius: 8px
  background: #FFFFFF
  border: 1px solid rgba(49, 95, 72, 0.1)

.section-title
  display: flex
  align-items: center
  gap: 9px
  margin-bottom: 14px

.index
  width: 30px
  height: 30px
  border-radius: 50%
  background: #315F48
  color: #FFFFFF
  display: inline-flex
  align-items: center
  justify-content: center
  font-size: 12px
  font-weight: 800
  flex: 0 0 30px

h2
  margin: 0
  font-size: 18px
  line-height: 1.35
  color: #26372E

.reason-list
  display: grid
  gap: 12px

.reason-item
  display: flex
  gap: 10px
  padding: 12px
  background: #F7FAF6
  border-radius: 8px

.dot
  width: 8px
  height: 8px
  border-radius: 50%
  background: #B85B35
  margin-top: 8px
  flex: 0 0 8px

h3
  margin: 0 0 6px
  font-size: 15px
  line-height: 1.4
  color: #27392F

p
  margin: 0
  color: #64756B
  font-size: 13px
  line-height: 1.6

.service-grid
  display: grid
  grid-template-columns: repeat(2, minmax(0, 1fr))
  gap: 10px

.service-card
  padding: 13px
  border-radius: 8px
  background: #F9F6EF
  border: 1px solid rgba(184, 91, 53, 0.12)

.service-icon
  width: 24px
  height: 24px
  border-radius: 50%
  background: #B85B35
  color: #FFFFFF
  display: inline-flex
  align-items: center
  justify-content: center
  font-size: 13px
  font-weight: 900
  margin-bottom: 10px

.scope-box
  border-radius: 8px
  overflow: hidden
  border: 1px solid rgba(49, 95, 72, 0.12)

.scope-row
  display: grid
  grid-template-columns: 96px 1fr
  min-height: 46px
  border-bottom: 1px solid rgba(49, 95, 72, 0.08)

.scope-row:last-child
  border-bottom: 0

.scope-label
  padding: 12px 10px
  background: #F0F6F0
  color: #315F48
  font-size: 13px
  font-weight: 800

.scope-value
  padding: 12px 10px
  color: #5A6E63
  font-size: 13px
  line-height: 1.5

.rule-list
  display: grid
  gap: 9px

.rule-item
  padding: 11px 12px
  border-radius: 8px
  background: #F7FAF6
  color: #52675C
  font-size: 13px
  line-height: 1.55

.choice-table
  border-radius: 8px
  overflow: hidden
  border: 1px solid rgba(49, 95, 72, 0.12)

.choice-row
  display: grid
  grid-template-columns: 1fr 1.15fr
  border-bottom: 1px solid rgba(49, 95, 72, 0.08)

.choice-row:last-child
  border-bottom: 0

.choice-row span
  padding: 12px 10px
  font-size: 13px
  line-height: 1.45
  color: #56695E

.choice-row span:last-child
  color: #315F48
  font-weight: 800

.choice-row.header
  background: #315F48

.choice-row.header span
  color: #FFFFFF
  font-weight: 800

.bottom-action
  position: fixed
  left: 50%
  bottom: 0
  transform: translateX(-50%)
  width: 100%
  max-width: 760px
  background: rgba(255, 255, 255, 0.96)
  border-top: 1px solid rgba(49, 95, 72, 0.12)
  padding: 10px 14px calc(10px + env(safe-area-inset-bottom))
  display: flex
  align-items: center
  justify-content: space-between
  gap: 12px
  box-shadow: 0 -10px 30px rgba(31, 54, 43, 0.1)

.bottom-copy
  display: grid
  gap: 3px
  min-width: 0

.bottom-title
  font-size: 15px
  color: #24372E
  font-weight: 900

.bottom-desc
  font-size: 12px
  color: #6D7D74

.buy-button
  border: 0
  border-radius: 8px
  background: #B85B35
  color: #FFFFFF
  font-weight: 900
  font-size: 15px
  height: 44px
  padding: 0 22px
  flex: 0 0 auto

@media (max-width: 420px)
  .content
    padding-left: 10px
    padding-right: 10px

  h1
    font-size: 25px

  .price-panel
    align-items: flex-start
    flex-direction: column

  .price-note
    text-align: left

  .service-grid
    grid-template-columns: 1fr

  .choice-row
    grid-template-columns: 1fr

  .choice-row span:first-child
    padding-bottom: 4px

  .choice-row span:last-child
    padding-top: 0
</style>
